import './Footer.css';

const Footer = () => {
  return (
    <footer className="dashboard-footer">
      <span>© {new Date().getFullYear()} Vaultize · Kryda Cloud</span>
    </footer>
  );
};

export default Footer;
